// latest: zhangmyh 2017-10-28 1:54 PM
// 鞍钢集团销售单位参照
import Collection from 'common/vo/collection'
import 'collection/docModelProperty'
import certClassList from 'collection/certificationClass'
// import 'collection/certificationClass'
import { find } from 'lodash'
import { Get } from 'common'
/* global $ u __ */

let _config
// 因后台接口返回数据格式不对 所以只能这么做 我也不想
const refreshTreeData = async function () {
  let data = await Get('/cpu-supplymgr/supplyDocModel/selectAll')
  let list = []
  data.data.forEach(function (item) {
    list.push({
      id: item.id,
      parentId: item.parentId || 0,
      name: item.name,
    })
  })
  // debugger
  certClassList.datatable.removeAllRows()
  certClassList.datatable.setSimpleData(list)
}
async function init (refer) {
  // 加载树
  // debugger
  // let tree = Collection.create('certification.classlist')
  // await tree.load()
  // tree.load()
  await refreshTreeData()
  // 每次都重新加载
  // await certClassList.load()
  // console.log(certClassList.datatable.getSimpleData())
  debugger
  let collection = Collection.create('supplydoc.modelprolist')
  let selectedData = []
  let selectflag = false
  let vm = {
    treemodel: certClassList.datatable,
    // treemodel: tree.datatable,
    treeOption: {
      callback: {
        beforeClick (id, obj) {
          // debugger
          collection.load({ pageSize: 10, groupId: obj.id })
        }
      }
    },
    config: {
      id: 'modelpro_grid',
      data: collection,
      type: 'grid',
      multiSelect: _config.multiSelect,
      editable: false,
      pagination: true,
      fields: [{
        field: 'name',
        dataType: 'String',
        title: __('name'),
        width: '48%'
      }, {
        field: 'group',
        dataType: 'String',
        title: '类型',
        width: '48%'
      }]
    }
  }
  let app = u.createApp()
  app.init(vm, $('#modelpro_refer')[0])

  // 提交事件
  refer.registerSubmitFunc(() => {
    return selectedData
  })
  collection.on('data', function (result) {
    if (_config.multiSelect) {
      let selectIndex = []
      if (selectedData.length > 0) {
        result.data.result.forEach(function (listItem, i) {
          selectedData.forEach(function (item) {
            if (item.id === listItem.id) {
              selectIndex.push(i)
            }
          })
        })
      } else if (refer.options.defaultData) {
        let defaultData = refer.options.defaultData()
        if (defaultData instanceof Array) {
          defaultData.forEach(function (item) {
            let flag = false
            result.data.result.forEach(function (listItem, i) {
              if (!flag && item.id === listItem.id) {
                selectIndex.push(i)
                selectedData.push({
                  id: listItem.id,
                  group: listItem.group,
                  name: listItem.name,
                  property: listItem.property,
                  type: listItem.type,
                  typeValue: listItem.typeValue,
                  strategy: listItem.strategy,
                  matchStrategy: listItem.matchStrategy,
                  maxLength: listItem.maxLength,
                  ag_rowtype: listItem.ag_rowtype
                })
                flag = true
              }
            })

            if (!flag) {
              selectedData.push(item)
            }
          })
        }
      }

      if (selectIndex.length > 0) {
        collection.datatable.setRowsSelect(selectIndex)
      }
    }
    selectflag = true
  })
  // 移除选择事件
  collection.datatable.on('unSelect', function (obj) {
    let selectData = collection.datatable.getRowByRowId(obj.rowIds[0])
    let index = -1
    selectedData.forEach(function (item, i) {
      if (item.id === selectData.getValue('id')) {
        index = i
      }
    })
    if (index >= 0) {
      selectedData.splice(index, 1)
    }
  })

  // 选择事件
  collection.datatable.on('select', function (obj) {
    function prepareData (data) {
      let item = find(collection.data.result, ['id', data.id.value])
      if (item) {
        let ag_rowtype = {}
        let type = item.type.toLowerCase()
        if (type == 'input') {
          let _type = item.typeValue.toLowerCase()
          ag_rowtype.editType = (_type != '') ? _type : 'string'
          if (item.maxLength > 0) {
            ag_rowtype.maxLength = item.maxLength
          }
        } else if (type == 'enum') {
          if (item.enumValueList) {
            ag_rowtype.editType = 'combo'
            ag_rowtype.options = item.enumValueList.map(function (option) {
              return {
                value: option.enumValue,
                name: option.enmuName
              }
            })
          } else {
            ag_rowtype.editType = 'string'
          }
        }
        return {
          id: data.id.value,
          group: data.group.value,
          name: data.name.value,
          property: data.property.value,
          type: data.type.value,
          typeValue: data.typeValue.value,
          strategy: data.strategy.value,
          matchStrategy: data.matchStrategy.value,
          maxLength: data.maxLength.value,
          ag_rowtype: JSON.stringify(ag_rowtype)
        }
      } else {
        return {}
      }
    }
    if (!_config.multiSelect) {
      let selectData = collection.datatable.getCurrentRow().data
      selectedData = prepareData(selectData)
      refer.submit()
      return
    }
    // 默认初始化已选择数据的时候不触发数据改变
    if (selectflag) {
      let selectData = collection.datatable.getRowByRowId(obj.rowIds[obj.rowIds.length - 1]).data
      selectedData.push(prepareData(selectData))
    }
  })
}

let template = require('./index.html')
export default function (config) {
  _config = Object.assign({
    multiSelect: true,
    repeatable: false
  }, config)

  return { init, template }
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/docModelProperty/index.js